/**
 * Rows per page. The first page also carries the masthead, the parties block and the summary strip, so it
 * fits fewer movements than the continuation pages. These are exact rather than approximate because every
 * table cell is single-line (`table-fixed` + `truncate`), which makes row height deterministic at 34px.
 *
 * Budget (A4 at 296mm ≈ 1118px): page 1: 1118 − (52 padding + 120 masthead + 150 parties + 92 summary + 32
 * title + 30 thead + 72 footer) = 570px → 16 rows; one dropped as slack for longer pt-BR labels and the last
 * page's total band (15 rows + the 28px band = 538px, still inside 570). page n: 1118 − (52 padding + 64
 * compact masthead + 30 thead + 72 footer) = 900px → 26 rows; two dropped for the same reason (24 rows + band
 * = 844px of 900).
 */
export const STATEMENT_FIRST_PAGE_ROWS = 15;
export const STATEMENT_CONT_PAGE_ROWS = 24;
